"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TableSortableProvider = exports.TableSortableContext = void 0;
var _react = require("react");
var TableSortableContext = /*#__PURE__*/(0, _react.createContext)({});
exports.TableSortableContext = TableSortableContext;
var TableSortableProvider = TableSortableContext.Provider;
exports.TableSortableProvider = TableSortableProvider;